import React from 'react';
import StarRatings from 'react-star-ratings';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2'; 

export const Rating = () => {
  return (
    <StarRatings
      rating={5}
      starRatedColor={colorsV2.yellow100}
      starDimension="18px"
      starSpacing="0px"
      svgIconViewBox="0 0 18 18"
      svgIconPath="M11.4151 14.6041C12.5913 15.2479 13.6258 14.4676 13.4008 13.102L12.9969 10.6501L14.7079 8.91362C15.6595 7.94787 15.2664 6.68244 13.9494 6.4832L11.5848 6.12547L10.5326 3.90566C9.94315 2.66223 8.66336 2.64885 8.07282 3.89463L7.01534 6.12547L4.65073 6.4832C3.33564 6.68216 2.93929 7.94651 3.89224 8.91362L5.60329 10.6501L5.19937 13.102C4.97472 14.4657 6.00719 15.2488 7.18511 14.6041L9.30008 13.4465L11.4151 14.6041Z"
      numberOfStars={5}
    />
  );
};

